import React from 'react'
import { DisplayAlert } from './Video.components'
import styled from 'styled-components'

type Props = {
  isPlaying: boolean
  url: string
}

type Error = {
  state: boolean
  message: string
}

export default function HTMLPlayer({ isPlaying, url }: Props) {
  const [error, setError] = React.useState<Error>()

  const streamingUrl = React.useMemo(() => {
    if (isPlaying) {
      return url
    }
  }, [isPlaying])

  const onError = () => {
    setError({ state: false, message: '出現無預期的錯誤' })
  }
  console.log('s', streamingUrl)
  return error ? (
    <DisplayAlert message={error.message} />
  ) : (
    <IFrame title="HTML Player" onError={onError} src={streamingUrl} />
  )
}

const IFrame = styled.iframe`
  width: 100%;
  height: 100%;
  background-color: #fff;
`
